import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-111544c6")

_pushScopeId("data-v-111544c6")
const _hoisted_1 = { class: "text" }
const _hoisted_2 = { class: "btn-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LogoffModal = _resolveComponent("LogoffModal")!

  return (_openBlock(), _createBlock(_component_LogoffModal, {
    visible: _ctx.props.visible,
    type: "success",
    onClose: _ctx.close,
    class: "account-verify-modal"
  }, {
    default: _withId(() => [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_1, _toDisplayString(_ctx.viewModel.logoffSuccessContent), 1),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVerify && _ctx.handleVerify(...args)))
          }, " 确定 ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
})